import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {Button, Grid} from '@mui/material';
import Carousel from 'react-multi-carousel';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import SetFee from './SetFee';
import {settingAction, settingApi} from '../../../services/TicketsServices';
import {museumApi} from '../../../services/MuseumServices';
import Moment from 'react-moment';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';

export default function FeeSetting() {
  const storedUser = JSON.parse(localStorage.getItem('user'));
  const userId = storedUser?.id;
  const [settings, setSettings] = useState([]);
  const [open, setOpen] = useState(false);
  const [museums, setMuseums] = useState([]);
  const [settingId, setSettingId] = useState();
  const responsive = {
    superLargeDesktop: {
      breakpoint: {max: 4000, min: 3000},
      items: 5
    },
    desktop: {
      breakpoint: {max: 3000, min: 1024},
      items: 3
    },
    tablet: {
      breakpoint: {max: 1024, min: 464},
      items: 2
    },
    mobile: {
      breakpoint: {max: 464, min: 0},
      items: 1,
      draggable: true
    }
  };

  useEffect(() => {
    getMuseumList();
  }, []);

  const getMuseumList = () => {
    museumApi('get', null, {per_page: 100}).then(response => {
      setMuseums(response?.data);
    });
  };

  useEffect(() => {
    getSetting();
  }, [userId]);

  const getSetting = () => {
    settingApi('get', userId,{per_page: 100}).then(res => {
      setSettings(res?.data)
    })
  };

  const handleOpen = () => {
    setOpen(true);
    setSettingId(null);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const editSetting = (id) => {
    setOpen(true);
    setSettingId(id);
  }

  const deleteButton = (id) => {
    settingAction('delete', id).then(res => {

    })
  }

  return (
    <Box>
      <Box className={'space-between'} sx={{mt: 5, mb: 2}}>
        <Typography className={'museum-font'}>Set Fee</Typography>
        <Button onClick={handleOpen} className={'text-capitalize border-radius-100'}
                variant={'contained'}
                color={'primary'}
        >
          + Set Fee
        </Button>
      </Box>
      <Carousel
        swipeable={true}
        draggable={true}
        showDots={false}
        responsive={responsive}
        ssr={true}
        infinite={false}
        autoPlaySpeed={1000}
        keyBoardControl={true}
        customTransition="transform 500ms ease-in-out"
        transitionDuration={500}
        containerClass="carousel-container"
        removeArrowOnDeviceType={['tablet', 'mobile']}
        // removeArrowOnDeviceType={['both']}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
      >
        {museums.length > 0 && museums?.map((museum, index) => {
          // Filter settings that belong to the current museum
          const museumSettings = settings.filter(setting => setting?.museum_id === museum?.id);

          return (
            <Box className="carousel-item" key={index}>
              <Box className={'position-relative'}>
                <img
                  draggable={'false'}
                  srcSet={museum?.photos?.[0]?.file}
                  src={museum?.photos?.[0]?.file}
                  alt={museum.title}
                  loading="lazy"
                  style={{width: '99%', height: 150, objectFit: 'cover'}}
                />
                <Box className={'position-absolute'} sx={{bottom: 12, left: 12, right: 0}}>
                  <Grid container>
                    <Grid item sm={10}>
                      <Typography className={'text-shadow white-color font-16 text-bold'}>{museum.name}</Typography>
                      <Typography className={'text-shadow white-color font-14'}>
                        {museum.gewog_name}, {museum.dzongkhag_name}
                      </Typography>
                      <Typography className={'text-shadow white-color font-14'}>
                        Date of establishment: <Moment format={'ll'}>{museum.date_of_establishment}</Moment>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              {museumSettings.map((setting, settingIndex) => (
                <Paper className={'box-shadow'} sx={{p: 1, m: 0.5, borderRadius: 2, backgroundColor: '#7c85a0'}}>
                <Grid container alignItems={'center'} spacing={2}>
                  <Grid item sm={10}>
                    <Box key={settingIndex}>
                      <Typography className={'white-color'}>
                        <span className={'text-capitalize'}>{setting.key}</span>: Nu. {setting.value || '0'}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item sm={2}>
                    <IconButton className={'hand-cursor'} onClick={() => editSetting(setting?.id)}>
                    <DriveFileRenameOutlineIcon sx={{color: '#fff'}}/>
                    </IconButton>
                  </Grid>
                </Grid>
                </Paper>
              ))}
            </Box>
          );
        })}
      </Carousel>
      {open &&
      <SetFee open={open} handleAction={handleClose} settingId={settingId} museums={museums} setMuseums={setMuseums}/>
      }
    </Box>
  );
}